// extracted by mini-css-extract-plugin
export var button = "_z-4";
export var hasDarkBackground = "_z-7";
export var hasLightBackground = "_z-6";
export var iconWrapper = "_z-0";
export var large = "_z-2";
export var medium = "_z-1";
export var small = "_z-5";
export var xsmall = "_z-3";